export default __webpack_public_path__ + "img/19.asset.7bec21ef.jpeg";